import Vue from 'vue';
import Vuex from 'vuex';
import {isCurrentAppSeller} from 'utils/appTypeState';

export const FETCH_INITIAL = 'FETCH_INITIAL';
let sellerStore = null;

if (isCurrentAppSeller()) {
  Vue.use(Vuex);


  sellerStore = new Vuex.Store({
    actions: {
      async [FETCH_INITIAL] (context) {
        const {FETCH_PROJECT_AND_ACCOUNT} = await import('store/modules/seller/sellerUser');
        await Promise.all([context.dispatch(`sellerUser/${FETCH_PROJECT_AND_ACCOUNT}`)]);
      }
    }
  });
}

export default sellerStore;
